import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Button, Spin, Descriptions, Table, Tag, Space, message } from 'antd';
import { ArrowLeftOutlined, FilePdfOutlined, SendOutlined } from '@ant-design/icons';
import { quotationApi } from '@/services/api';
import dayjs from 'dayjs';

const QuotationDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [quotation, setQuotation] = useState(null);

  useEffect(() => {
    loadQuotation();
  }, [id]);

  const loadQuotation = async () => {
    setLoading(true);
    try {
      const response = await quotationApi.get(id);
      if (response.data.success) {
        setQuotation(response.data.data);
      }
    } catch (error) {
      message.error('載入報價單失敗');
    } finally {
      setLoading(false);
    }
  };

  if (loading || !quotation) {
    return (
      <Card>
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
        </div>
      </Card>
    );
  }

  const columns = [
    {
      title: 'SKU',
      dataIndex: ['product', 'sku'],
      key: 'sku'
    },
    {
      title: '商品名稱',
      dataIndex: ['product', 'product_name'],
      key: 'product_name'
    },
    {
      title: '數量',
      dataIndex: 'quantity',
      key: 'quantity'
    },
    {
      title: '單價',
      dataIndex: 'unit_price',
      key: 'unit_price',
      render: (price) => `NT$ ${parseFloat(price).toLocaleString()}`
    },
    {
      title: '小計',
      dataIndex: 'subtotal',
      key: 'subtotal',
      render: (price) => `NT$ ${parseFloat(price).toLocaleString()}`
    }
  ];

  return (
    <div>
      <Card>
        <Space style={{ marginBottom: 16 }}>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/quotations')}>
            返回
          </Button>
          <Button icon={<SendOutlined />}>
            發送報價單
          </Button>
          <Button icon={<FilePdfOutlined />}>
            下載 PDF
          </Button>
        </Space>

        <Descriptions title="報價單資訊" bordered column={2}>
          <Descriptions.Item label="報價單號">{quotation.quotation_no}</Descriptions.Item>
          <Descriptions.Item label="狀態">
            <Tag>{quotation.status}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="聯絡人">{quotation.contact_name}</Descriptions.Item>
          <Descriptions.Item label="電話">{quotation.contact_phone}</Descriptions.Item>
          <Descriptions.Item label="地址" span={2}>{quotation.address}</Descriptions.Item>
          <Descriptions.Item label="建立日期">
            {dayjs(quotation.created_at).format('YYYY-MM-DD')}
          </Descriptions.Item>
          <Descriptions.Item label="有效期限">
            {dayjs(quotation.valid_until).format('YYYY-MM-DD')}
          </Descriptions.Item>
        </Descriptions>

        <div style={{ marginTop: 24 }}>
          <h3>商品明細</h3>
          <Table
            columns={columns}
            dataSource={quotation.items || []}
            pagination={false}
            rowKey="id"
          />
        </div>

        <div style={{ marginTop: 24, textAlign: 'right' }}>
          <Space direction="vertical" size="small" style={{ width: 300 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>小計（未稅）:</span>
              <strong>NT$ {parseFloat(quotation.subtotal_excl_tax).toLocaleString()}</strong>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>稅額:</span>
              <strong>NT$ {parseFloat(quotation.tax_amount).toLocaleString()}</strong>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 18 }}>
              <span>總計:</span>
              <strong style={{ color: '#ff4d4f' }}>
                NT$ {parseFloat(quotation.grand_total).toLocaleString()}
              </strong>
            </div>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default QuotationDetail;
